import {API} from '../API';

export class ItemService {

  async saveItem(order, data) {
    let method = 'post';
    let url = `purchase-orders/${order.id}/items`;
    if (data.id) {
      method = 'put';
      url = `${url}/${data.id}`;
    }
    return (await API.getConnection())
      [method](url, data)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async deleteItem(order, item) {
    return (await API.getConnection())
      .delete(`purchase-orders/${order.id}/items/${item.id}`)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async reorderItems(order, items) {
    return (await API.getConnection())
      .put(`purchase-orders/${order.id}/items`, {items})
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }
}
